require('../../sass/components/_textarea.scss');

export const Textarea = {
    name: 'Textarea',
    inheritAttrs: false,
    props: {
        isInvalid: Boolean,
        inputClasses: String,
        value: [String, Number],
        disabled: Boolean,
    },
    computed: {
        classes() {
            return [
                'textarea',
                this.isInvalid && 'textarea--invalid',
                this.inputClasses
            ];
        },
        listeners() {
            const {input, ...listeners} = this.$listeners;
            return {
                ...listeners,
                input: (e) => {
                    input(e.target.value);
                }
            };
        },
    },
    template: `
        <textarea
                :class="classes"
                :value="value"
                v-on="listeners"
                :disabled="disabled"
                v-bind="$attrs"/>
    `
};